<template>
  <div class="single-flash-poster">
    <h5 style="color: #fff"><span></span>3D半身像界面</h5>

    <poster-table
      :project="project"
      :skin-id="skinId"
      :poster-url="posterUrl"
      :poster-more-url="posterMoreUrl"
      dateColumnLabel="日期"
      :metricColumns="metricColumns"
      showActionColumn
    />
  </div>
</template>

<script>
import PosterTable from './PosterTable.vue'

export default {
  name: 'SingleFlashPoster',
  components: {
    PosterTable,
  },
  props: {
    project: {
      type: [String, Number],
      default: 57,
    },
    // 主数据请求地址
    posterUrl: {
      type: String,
      default: '/report/3d_half_body_data/',
    },
    // 「查看更多」分页数据请求地址
    posterMoreUrl: {
      type: String,
      default: '/report/3d_half_body_data_more/',
    },
  },

  data() {
    return {
      metricColumns: [
        { label: '平均帧率(高于)', key: 'avg_fps' },
        { label: 'CPU占用率均值(低于)', key: 'avg_cpu' },
        { label: '内存均值(低于)', key: 'avg_pss' },
        { label: '内存峰值(低于)', key: 'max_pss' },
      ],
    }
  },

  computed: {
    skinId() {
      return this.$route?.query?.skin_id
    },
  },
}
</script>

<style scoped>
.single-flash-poster {
  margin-top: 48px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  padding: 10px 4px;
}
</style>
